import React from 'react';
import { Route } from 'react-router-dom';
import _ from 'lodash';

import RenderContent from 'app/components/layout/RenderContent';
import HeaderThin from 'app/components/layout/HeaderThin';
import ProgressIndicator, { IStep } from 'app/components/general/ProgressIndicator';

import CartMatch from './components/CartMatch';
import CartBulkMatches from './components/CartBulkMatches';
import CartForfeit from './components/CartForfeit';
import Checkout from './components/Checkout';
import Receipt from './components/Receipt';

interface IMakePaymentLayoutProps {
  match: any;
}
export default class MakePaymentLayout extends React.Component<
IMakePaymentLayoutProps,
{}
> {
  static defaultProps: IMakePaymentLayoutProps = {
    match: undefined,
  };

  render() {
    const steps: IStep[] = [
      {
        number: 1,
        text: 'Review Payment',
        complete: _.includes(
          ['/payment/match/:matchPaymentId/pay', '/payment/multiple-matches/:bulkMatchPaymentId/pay', '/payment/match/:matchPaymentId/receipt', '/payment/multiple-matches/:bulkMatchPaymentId/receipt', '/payment/forfeit/:forfeitId/pay', '/payment/forfeit/:forfeitId/receipt'],
          this.props.match.path,
        ),
        active: _.includes(
          ['/payment/match/:matchPaymentId/review', '/payment/forfeit/:forfeitId/review', '/payment/multiple-matches/:bulkMatchPaymentId/review'],
          this.props.match.path,
        ),
      },
      {
        number: 2,
        text: 'Confirm & Pay',
        complete: _.includes(
          ['/payment/match/:matchPaymentId/receipt', '/payment/multiple-matches/:bulkMatchPaymentId/receipt', '/payment/forfeit/:forfeitId/receipt'],
          this.props.match.path,
        ),
        active: _.includes(
          ['/payment/match/:matchPaymentId/pay', '/payment/multiple-matches/:bulkMatchPaymentId/pay', '/payment/forfeit/:forfeitId/pay'],
          this.props.match.path,
        ),
      },
      {
        number: 3,
        text: 'Receipt',
        complete: _.includes(
          ['/payment/match/:matchPaymentId/receipt', '/payment/multiple-matches/:bulkMatchPaymentId/receipt', '/payment/forfeit/:forfeitId/receipt'],
          this.props.match.path,
        ),
        active: false,
      },
    ];
    const title = _.includes(
      ['/payment/match/:matchPaymentId/receipt', '/payment/multiple-matches/:bulkMatchPaymentId/receipt', '/payment/forfeit/:forfeitId/receipt'],
      this.props.match.path,
    ) ? 'Receipt' : 'Make Payment';
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="row">
          <div className="col">
            <HeaderThin title={title} divider />
          </div>
        </div>
        <div className="row">
          <div className="col col-12 col-lg-10 col-xl-8">
            <ProgressIndicator steps={steps} />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col col-12 col-lg-10 col-xl-8">
            <Route
              exact
              path={['/payment/match/add/:matchPaymentId/review']}
              render={() => <CartMatch {...this.props} />}
            />

            <Route
              exact
              path={['/payment/match/:matchPaymentId/review']}
              render={() => <CartMatch {...this.props} />}
            />

            <Route
              exact
              path={['/payment/multiple-matches/:bulkMatchPaymentId/review']}
              render={() => <CartBulkMatches {...this.props} />}
            />

            <Route
              exact
              path={['/payment/match/:matchPaymentId/pay']}
              render={() => <Checkout {...this.props} />}
            />

            <Route
              exact
              path={['/payment/match/add/:matchPaymentId/pay']}
              render={() => <Checkout {...this.props} />}
            />

            <Route
              exact
              path={['/payment/multiple-matches/:bulkMatchPaymentId/pay']}
              render={() => <Checkout {...this.props} />}
            />

            <Route
              exact
              path={['/payment/match/:matchPaymentId/receipt']}
              render={() => <Receipt {...this.props} />}
            />

            <Route
              exact
              path={['/payment/multiple-matches/:bulkMatchPaymentId/receipt']}
              render={() => <Receipt {...this.props} />}
            />

            <Route
              exact
              path={['/payment/forfeit/:forfeitId/review']}
              render={() => <CartForfeit {...this.props} />}
            />

            <Route
              exact
              path={['/payment/forfeit/:forfeitId/pay']}
              render={() => <Checkout {...this.props} />}
            />

            <Route
              exact
              path={['/payment/forfeit/:forfeitId/receipt']}
              render={() => <Receipt {...this.props} />}
            />
          </div>
        </div>
      </RenderContent>
    );
  }
}
